import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { short } from '../../common/formatting/date';
import { SelectRaw } from '../../../../components';

export default class AssignmentModal extends Component {
	static propTypes = {
		isOpen: PropTypes.bool.isRequired,
		onSave: PropTypes.func.isRequired,
		onCancel: PropTypes.func.isRequired,
		patient: PropTypes.object,
		attributeGroups: PropTypes.array,
		attributeGroupAssignments: PropTypes.array,
		questionnaireGroups: PropTypes.array,
		questionnaireGroupAssignments: PropTypes.array,
		connectedProviders: PropTypes.array,
	}

	constructor(props) {
		super(props);

		this.state = {
			attributeGroupSelections: {},
			questionnaireGroupSelections: {}
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.attributeGroups && nextProps.attributeGroups.length > 0) {
			const attributeGroupSelections = {};
			nextProps.attributeGroups.forEach(attributeGroup => {
				attributeGroupSelections[attributeGroup.id] = {
					checked: false
				};
			});
			this.setState({
				attributeGroupSelections
			});
		}
		if (nextProps.questionnaireGroups && nextProps.questionnaireGroups.length > 0) {
			const questionnaireGroupSelections = {};
			nextProps.questionnaireGroups.forEach(questionnaireGroup => {
				questionnaireGroupSelections[questionnaireGroup.id] = false;
			});
			this.setState({
				questionnaireGroupSelections
			});
		}
		if (nextProps.attributeGroupAssignments && nextProps.attributeGroupAssignments.length >= 0) {
			nextProps.attributeGroupAssignments.forEach(assignment => {
				this.setState(currState => ({
					attributeGroupSelections: {
						...currState.attributeGroupSelections,
						[assignment.providerPracticeProgramId]: {
							checked: true,
							providerId: assignment.providerId
						}
					}
				}));
			});
		}
		if (nextProps.questionnaireGroupAssignments && nextProps.questionnaireGroupAssignments.length >= 0) {
			nextProps.questionnaireGroupAssignments.forEach(assignment => {
				this.setState(currState => ({
					questionnaireGroupSelections: {
						...currState.questionnaireGroupSelections,
						[assignment.care_quest_groupId]: true
					}
				}));
			});
		}
	}

	handleSave = () => {
		this.props.onSave(this.state);
	}

	handleAttributeGroupSelectionChange = (attributeGroupId, checked) => {
		this.setState(currState => ({
			attributeGroupSelections: {
				...currState.attributeGroupSelections,
				[attributeGroupId]: {
					checked
				}
			}
		}));
	}

	handleAttributeGroupProviderChange = (attributeGroupId, providerId) => {
		let selectedProvider;
		if (providerId != '-1') {
			selectedProvider = providerId;
		}
		this.setState(currState => ({
			attributeGroupSelections: {
				...currState.attributeGroupSelections,
				[attributeGroupId]: {
					checked: true,
					providerId: selectedProvider
				}
			}
		}));
	}

	handleQuestionnairGroupSelectionChange = (questionnaireGroupId, checked) => {
		this.setState(currState => ({
			questionnaireGroupSelections: {
				...currState.questionnaireGroupSelections,
				[questionnaireGroupId]: checked
			}
		}));
	}

	render() {
		const { isOpen, onCancel, patient, attributeGroups, questionnaireGroups, connectedProviders } = this.props;
		const { attributeGroupSelections, questionnaireGroupSelections } = this.state;

		return (
			<Modal
				isOpen={isOpen}
				contentLabel="Patient Group Assignments"
				className="modal-dialog patient-group-assignments modal-xl"
			>
				<div className="modal-content">
					<div className="modal-header">
						<button type="button" data-dismiss="modal" aria-label="Close" className="close" onClick={onCancel}>
							<em className="fa fa-times" />
						</button>
						<h4 className="modal-title">Patient Group Assignments</h4>
					</div>
					<div className="modal-body">
						<div>
							{patient && (
								<div>
									<h3 className="mt0">
										{`${patient.patient_name_last}, ${patient.patient_name_first}`}
										{patient.gender && ` (${patient.gender})`}
										<small className="ml">CareConvene ID: {patient.patientId}</small>
									</h3>
									<ul className="list-unstyled list-inline">
										{patient.patient_dob && (
											<li className="mb-sm"><em className="fa fa-birthday-cake fa-fw"></em>{short(patient.patient_dob)}</li>
										)}
										{(patient.address || patient.city || patient.state || patient.zip) && (
											<li className="mb-sm"><em className="fa fa-map-marker fa-fw"></em>{[patient.address, patient.city, patient.state, patient.zip].join(' ')}</li>
										)}
										{patient.email && (
											<li className="mb-sm"><em className="fa fa-envelope fa-fw"></em>{short(patient.email)}</li>
										)}
										{patient.phone_mobile && (
											<li className="mb-sm"><em className="fa fa-mobile-phone fa-fw"></em>{short(patient.phone_mobile)}</li>
										)}
									</ul>
								</div>
							)}
						</div>
						<div className="row">
							<div className="col-md-6 form-horizontal">
								<h3 className="bb pb">Attribute Groups</h3>
								{attributeGroups && attributeGroups.map(attributeGroup => (
									<div key={attributeGroup.id} className="form-group">
										<label className="col-sm-6 control-label">{attributeGroup.program_name}</label>
										<div className="col-sm-1">
											<label className="switch">
												<input
													type="checkbox"
													checked={attributeGroupSelections[attributeGroup.id].checked}
													onChange={({ target }) => this.handleAttributeGroupSelectionChange(attributeGroup.id, target.checked)}
												/>
												<span />
											</label>
										</div>
										<div className="col-sm-5">
											{attributeGroupSelections[attributeGroup.id].checked && (
												<div>
													<div><strong>Data Sharing Provider</strong></div>
													<SelectRaw
														onChange={({ target }) => this.handleAttributeGroupProviderChange(attributeGroup.id, target.value)}
														selectedValue={attributeGroupSelections[attributeGroup.id].providerId || ''}
														options={[{ label: 'None', value: -1 }, ...connectedProviders.map((provider) => ({ label: `${provider.name_first} ${provider.name_last}`, value: provider.id }))]}
													/>
												</div>
											)}
										</div>
									</div>
								))}
							</div>
							<div className="col-md-6 form-horizontal">
								<h3 className="bb pb">Questionnaire Groups</h3>
								{questionnaireGroups && questionnaireGroups.map(questionnaireGroup => (
									<div key={questionnaireGroup.id} className="form-group">
										<label className="col-sm-6 control-label">{questionnaireGroup.name}</label>
										<div className="col-sm-6">
											<label className="switch">
												<input
													type="checkbox"
													checked={questionnaireGroupSelections[questionnaireGroup.id]}
													onChange={({ target }) => this.handleQuestionnairGroupSelectionChange(questionnaireGroup.id, target.checked)}
												/>
												<span />
											</label>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<button className="btn btn-default btn-lg" onClick={onCancel}>Cancel</button>
						<button className="btn btn-primary btn-lg ml" onClick={this.handleSave}>Save</button>
					</div>
				</div>
			</Modal>
		);
	}
}
